export { default } from './LoadingButton';



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingButton/index.jsx